export default function EmptyState({ icon: Icon, title, description, action, compact = false }) {
  return (
    <div className={`text-center ${compact ? 'py-8' : 'py-16'}`}>
      {Icon && (
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-neutral-100 dark:bg-neutral-700 mb-4">
          <Icon className="w-6 h-6 text-neutral-400 dark:text-neutral-500" />
        </div>
      )}
      <p className="text-neutral-600 dark:text-neutral-400 font-medium">{title}</p>
      {description && (
        <p className="text-neutral-400 dark:text-neutral-500 text-sm mt-1">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
